// extracted by mini-css-extract-plugin
module.exports = {"specialTip":"index_specialTip__1F1v-","ordinaryTip":"index_ordinaryTip__YuZL2"};